// extracted by mini-css-extract-plugin
module.exports = {"fio-suggest":"_6c97079b1b--fio-suggest--31lLX","fio-item":"_6c97079b1b--fio-item--2KKEU"};